<template>
  <div>
    <PageHeader title="Dit is nog niet af"
                :image="require('@/assets/images/jonathan-cooper-VxO9SHCKK68-unsplash.jpg')">
      Mijn site is nog niet helemaal gevuld. Maar ik ben er hard mee bezig.
      Heb je in de tussentijd een vraag, schroom niet om mij te mailen:
      <a href="mailto:jason@voiceoveracteur.nl">jason@voiceoveracteur.nl</a>.
      Of vul het
      <RouterLink to="/contact">contactformulier</RouterLink>
      in.
    </PageHeader>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader.vue';
import ContactForm from '@/components/ContactForm.vue';

export default {
  name: 'Contact.vue',
  components: { PageHeader },
};
</script>
